import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FAE_56 } from "@/lib/programData";

export default function FezAtlasErrachidia56Page() {
  return <ProgramTemplate program={PROGRAM_FAE_56} variant="fae" showJourneyChronology />;
}
